import { XAxis } from "recharts";

const BaseXAxis = XAxis

export default BaseXAxis;